const buildEnv = process.env.BUILD_ENV

const prodRoutes = {
  skipper: {
    path: '/skipper',
    component: 'src/pages/Skipper/index.js',
    title: 'Empréstimo FGTS',
    category: 'proposal'
  },
  fgts: {
    path: '/',
    component: 'src/pages/Home/index.js',
    title: 'Empréstimo FGTS Itaú - Antecipe seu saque hoje mesmo',
    category: 'home'
  },
  fgtsTelhaNorte: {
    path: '/telhanorte',
    component: 'src/pages/Home/partners/telhanorte.js',
    title: 'Empréstimo FGTS Itaú Telhanorte - Antecipe seu saque hoje mesmo',
    category: 'home'
  },
  fgtsMagalu: {
    path: '/magalu',
    component: 'src/pages/Home/partners/magalu.js',
    title: 'Empréstimo FGTS Itaú Magalu - Antecipe seu saque hoje mesmo',
    category: 'home'
  },
  assai: {
    path: '/assai',
    component: 'src/pages/Home/partners/assai.js',
    title:
      'Empréstimo FGTS Itaú Assaí Atacadista - Antecipe seu saque hoje mesmo',
    category: 'home'
  },
  fgtsPirelli: {
    path: '/pirelli',
    component: 'src/pages/Home/partners/pirelli.js',
    title: 'Empréstimo FGTS Itaú Pirelli - Antecipe seu saque hoje mesmo',
    category: 'home'
  },
  fgtsCarrefour: {
    path: '/carrefour',
    component: 'src/pages/Home/partners/carrefour.js',
    title: 'Empréstimo FGTS Itaú Carrefour - Antecipe seu saque hoje mesmo',
    category: 'home'
  },
  fgtsCrediffato: {
    path: '/crediffato',
    component: 'src/pages/Home/partners/crediffato.js',
    title: 'Empréstimo FGTS Itaú Crediffato - Antecipe seu saque hoje mesmo',
    category: 'home'
  },
  fgtsAtacadao: {
    path: '/atacadao',
    component: 'src/pages/Home/partners/atacadao.js',
    title: 'Empréstimo FGTS Itaú Atacadão - Antecipe seu saque hoje mesmo',
    category: 'home'
  },
  smsCodeVerification: {
    path: '/proposta/verificacao-codigo-sms',
    component: 'src/pages/Proposal/SmsCodeVerification/index.js',
    title: 'Empréstimos FGTS | Proposta Verificação SMS',
    category: 'proposal'
  },
  proposal: {
    path: '/proposta',
    component: 'src/pages/Proposal/BasicData/index.js',
    title: 'Empréstimos FGTS | Proposta',
    category: 'proposal'
  },
  resultadoFgtsIneligible: {
    path: '/resultado/final-screen-fgts-ineligible',
    component: 'src/pages/Result/FgtsIneligible/index.js',
    title: 'Empréstimos FGTS | Final',
    category: 'proposal'
  },
  resultadoFgtsPartnerIneligible: {
    path: '/resultado/final-screen-fgts-partner-ineligible',
    component: 'src/pages/Result/FgtsPartnerIneligible/index.js',
    title: 'Empréstimos FGTS | Final',
    category: 'proposal'
  },
  resultadoFgtsSuccess: {
    path: '/resultado/final-screen-fgts-success',
    component: 'src/pages/Result/FgtsSuccess/index.js',
    title: 'Empréstimos FGTS | Final',
    category: 'proposal'
  },
  resultadoFgtsWebAppSuccess: {
    path: '/resultado/final-screen-fgts-web-app',
    component: 'src/pages/Result/FgtsWebAppSuccess/index.js',
    title: 'Empréstimos FGTS | Final',
    category: 'proposal'
  },
  searchingCredit: {
    path: '/proposta/pesquisando-credito',
    component: 'src/pages/SearchingCredit/index.js',
    title: 'Empréstimos FGTS | Procurando Ofertas',
    category: 'proposal'
  },
  offers: {
    path: '/proposta/ofertas',
    component: 'src/pages/Offers/index.js',
    title: 'Empréstimos FGTS | Ofertas',
    category: 'proposal'
  },
  notFound: {
    path: '/nao-encontrado',
    component: 'src/pages/404/index.js',
    title: 'Empréstimos FGTS | Página não encontrada',
    category: 'proposal'
  },
  allowFgtsApp: {
    path: '/proposta/permitir-app-fgts',
    component: 'src/pages/AllowFgtsApp/index.js',
    title: 'Empréstimos FGTS | Permitir App Fgts',
    category: 'proposal'
  },
  cep: {
    path: '/proposta/localizacao',
    component: 'src/pages/Proposal/CEP/index.js',
    title: 'Empréstimos FGTS | Proposta CEP ',
    category: 'proposal'
  },
  sellerId: {
    path: '/proposta/dados-vendedor',
    component: 'src/pages/Proposal/SellerId/index.js',
    title: 'Empréstimos FGTS | Dados do Vendedor',
    category: 'proposal'
  },
  FormalizationPersonalDataFGTS: {
    path: '/proposta/dados-pessoais-formalizacao',
    component: 'src/pages/Formalization/PersonalData/index.js',
    title: 'Empréstimo FGTS | Formalização Dados Pessoais ',
    category: 'proposal'
  },
  FormalizationDocument: {
    path: '/proposta/formalizacao-documento',
    component: 'src/pages/Formalization/Documentation/index.js',
    title: 'Empréstimo FGTS | Formalização Documento ',
    category: 'proposal'
  },
  FormalizationAddress: {
    path: '/proposta/endereco-residencial',
    component: 'src/pages/Formalization/Address/index.js',
    title: 'Empréstimo FGTS | Formalização Endereço ',
    category: 'proposal'
  },
  FormalizationBanking: {
    path: '/proposta/dados-bancarios',
    component: 'src/pages/Formalization/BankData/index.js',
    title: 'Empréstimo FGTS | Formalização Dados Bancários ',
    category: 'proposal'
  },
  LoanReason: {
    path: '/proposta/objetivo',
    component: 'src/pages/Formalization/LoanReason/index.js',
    title: 'Empréstimo FGTS | Formalização ',
    category: 'proposal'
  },
  FormalizationFinished: {
    path: '/proposta/sms-formalizacao',
    component: 'src/pages/Formalization/Finished/index.js',
    title: 'Empréstimo FGTS | Formalização ',
    category: 'proposal'
  },
  pendingOfferError: {
    path: '/proposta-pendente/erro',
    component: 'src/pages/PendingOffer/Error/index.js',
    title: 'Empréstimo FGTS | Error',
    category: 'proposal'
  },
  blockedBenefit: {
    path: '/proposta-pendente/beneficio-bloqueado',
    component: 'src/pages/PendingOffer/BlockedBenefit/index.js',
    title: 'Empréstimo FGTS | Benefício Bloqueado ',
    category: 'proposal'
  },
  pendingOfferPhotoError: {
    path: '/proposta-pendente/erro-foto',
    component: 'src/pages/PendingOffer/PhotoError/index.js',
    title: 'Empréstimo FGTS | Erro na foto',
    category: 'proposal'
  },
  pendingOfferData: {
    path: '/proposta-pendente/dados-divergentes',
    component: 'src/pages/PendingOffer/Data/index.js',
    title: 'Empréstimo FGTS | Dados divergentes',
    category: 'proposal'
  },
  pendingOfferFormalization: {
    path: '/proposta-pendente/formalizacao-nao-finalizada',
    component: 'src/pages/PendingOffer/Formalization/index.js',
    title: 'Empréstimo FGTS | Formalização não finalizada',
    category: 'proposal'
  },
  resultadoZflowLink: {
    path: '/resultado/final-screen-zflow-link',
    component: 'src/pages/Result/FgtsZflowLink/index.js',
    title: 'Empréstimos FGTS | Final',
    category: 'proposal'
  }
}

const notProdFGTSRoutes = {}

const fgtsRoutes =
  buildEnv === 'production'
    ? prodRoutes
    : { ...prodRoutes, ...notProdFGTSRoutes }

module.exports = fgtsRoutes
